// src/components/ProjectSectionHeader.js
import React from "react";
import "./ProjectSectionHeader.css";

export default function ProjectSectionHeader({ collapsed, onToggle }) {
  return (
    <div className="project-section-header">
      <h2 className="title">Your Projects</h2>
      <button
        className="toggle"
        onClick={onToggle}
        aria-expanded={!collapsed}
        aria-controls="projects-section"
        title={collapsed ? "Show Projects" : "Hide Projects"}
      >
        {collapsed ? "Show" : "Hide"}
      </button>
    </div>
  );
}
